import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';

@Component({
  selector: 'app-project-list-modal',
  templateUrl: './project-list-modal.component.html',
  styleUrls: ['./project-list-modal.component.scss']
})
export class ProjectListModalComponent implements OnInit {

  projectList: any;

  projectInfo:any = {
    "id": 1619,
    "name": "Antriksh Kanball - Google",
    "created_at": "2024-08-21T18:50:22.000+05:30",
    "updated_at": "2024-08-21T18:50:24.000+05:30",
    "client_id": 521,
    "disable": false,
    "api_identifier": "78b4dffd21084d1fa2c11312f3727105",
    "emails_to_notify_on_form_submit": [],
    "auto_verify": false,
    "client_auto_assign": true,
    "notify_user_on_form_submit": false,
    "location": "2/A, Express Zenith, Sector 77, Noida, Uttar Pradesh 201304, India",
    "city": "Noida",
    "country": "India",
    "completion_status": null,
    "developer": null,
    "amenities": [],
    "roads": [],
    "wow_factors": [],
    "description": null,
    "min_price": "8000000",
    "offers": null,
    "lead_expiry": 48,
    "qualified": true,
    "my_registration_time_limit": 48,
    "remove_negative": false,
    "is_status_changed_after_tat": true,
    "remove_not_intrested": false,
    "client_sms_enabled": false,
    "telephony": true,
    "recording_access_to_client": false,
    "is_live": true,
    "latitude": "28.569555",
    "longitude": "77.391295",
    "possession": "2222-01-01T00:00:00.000+05:30",
    "project_type": "Residential",
    "whatsapp_enabled": false,
    "max_price": null,
    "campaign_days": 30,
    "campaign_leads_to_be_generated": 150,
    "inventory": [],
    "delivery_mode": null,
    "super_project_id": 61,
    "cluster_id": null,
    "allow_shuffling": false,
    "minPrice": 0,
    "maxPrice": 0,
    "min_size": 0,
    "max_size": 0,
    "rera_id": "UPRERA/123-xyz",
    "allowed_duplicate_lead": false,
    "project_deal_type": "CPL",
    "approved": false,
    "sales_account_id": null,
    "campaign_target_end_date": "2024-09-20",
    "campaign_id": 121,
    "client": {
        "id": 521,
        "name": "Antriksh",
        "created_at": "2024-08-21T18:38:04.000+05:30",
        "updated_at": "2024-08-21T18:38:04.000+05:30",
        "disable": false,
        "parent_id": null,
        "allow_app_login": false,
        "is_broker": false,
        "rera": "",
        "city": "Noida",
        "tracking_unattended_lead": false,
        "unattended_lead_count_overhead": 3
    },
    "form_api": "submit_lead/769efb1cabfb4765af3d6798e500fbda/78b4dffd21084d1fa2c11312f3727105"
}

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private router: Router,
    private dialogRef: MatDialogRef<ProjectListModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data) {
    this.projectList = this.data
    console.log(this.projectList)
  }

  ngOnInit() {
  }

  goToProjectDetail(project) {
      sessionStorage.setItem("projectInfo", JSON.stringify(this.projectInfo))
      // this.router.navigate([]).then(result => { window.open('/page/project/leads/' + project.id, '_blank'); });
      this.router.navigate([]).then(result => { window.open('/page/project/leads/' + 1619, '_blank'); });
  }

  close() {
    this.dialogRef.close();
  }

}
